import React from 'react';

export const NotFound = () => {
    return (
        <h3>
            <center>
                The page you&apos;re looking for doesn&apos;t exist.
            </center>
        </h3>
    );
};

export default NotFound;